import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Product } from '@core/model/product.model';
import { ProductService, WarehouseService } from '@app/core';
import { Warehouse } from '@core/model/warehouse.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.css']
})
export class WarehouseComponent implements OnInit {
  warehouseForm: FormGroup;
  products: Product[];
  warehouses: Warehouse[];

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private warehouseService: WarehouseService
  ) {}

  ngOnInit() {
    // this.createForm();
    // this.listProducts();
    // this.listWarehouse();
  }

  createForm() {
    this.warehouseForm = this.formBuilder.group({
      cantidad: ['', [Validators.required]],
      fecha_ingreso: [
        new Date().toISOString().substring(0, 10),
        [Validators.required]
      ],
      precio_compra: ['', [Validators.required]],
      precio_venta: ['', [Validators.required]],
      producto_id: ['', [Validators.required]]
    });
  }

  listProducts() {
    this.productService.getProductosAlmacen().subscribe(
      date => {
        this.products = date;
        console.log(date);
      },
      error1 => {
        console.log(error1.error);
      }
    );
  }

  listWarehouse() {
    this.warehouseService.getAll().subscribe(
      data => {
        this.warehouses = data;
        //  console.log(data);
      },
      error => {
        console.log(error.error);
      }
    );
  }

  registerWarehouse() {
    const newWareHouse = new Warehouse();
    console.log(this.warehouseForm.value);
    newWareHouse.cantidad = this.warehouseForm.value.cantidad;
    newWareHouse.fecha_ingreso = this.warehouseForm.value.fecha_ingreso;
    newWareHouse.precio_compra = this.warehouseForm.value.precio_compra;
    newWareHouse.precio_venta = this.warehouseForm.value.precio_venta;
    newWareHouse.producto_id = this.warehouseForm.value.producto_id;

    this.warehouseService.create(newWareHouse).subscribe(
      data => {
        console.log(data);
        Swal.fire(data);
        this.warehouseForm.reset();
        this.listWarehouse();
      },
      error => {
        Swal.fire(error);
        console.log(error.error);
      }
    );
  }
}
